import React from "react";
import { Link } from "react-router-dom";
import "../Styles/Footer.scss";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footerContainer">
      <div className="footerContent">
        <p className="copyrightText">
          Copyright © 2026 iNextLabs - All Rights Reserved
        </p>
        <div className="footerRight">
          <ul className="socialMediaWrapper">
            <li className="icon facebook">
              <Link
                to="https://www.facebook.com/iNextLabs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF size={15} />
              </Link>
            </li>
            <li className="icon twitter">
              <Link
                to="https://twitter.com/inextlabs"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <FaTwitter size={15} />
              </Link>
            </li>
            <li className="icon instagram">
              <Link
                to="https://www.instagram.com/inextlabs/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram size={15} />
              </Link>
            </li>
            <li className="icon youtube">
              <Link
                to="https://www.youtube.com/channel/UCJDvWr__3VODxszufzBUHcw"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube size={15} />
              </Link>
            </li>
          </ul>
          <a href="mailto:info@inextlabs.com" className="footerEmail">
            info@inextlabs.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
